import gql from "graphql-tag";
import RankedIssuerFields from "lib/fragments/RankedIssuerFields";
import ExecutiveCompensationHistoryItemFields from "lib/graphql/fragments/ExecutiveCompensationHistoryItemFields";
import CoverFields from "lib/graphql/fragments/issuer/CoverFields";
import MorningstarPersonFields from "lib/graphql/fragments/MorningstarPersonFields";
import TrailingReturnsFields from "lib/graphql/fragments/TrailingReturnsFields";

export default gql`
  fragment AmericanCompanyIssuerTopLevel on AmericanCompanyIssuer {
    _id
    irs
    name
    sector
    isREIT
    exchange
    listingExchange
    businessDescription
    shortBusinessDescription
    tickerSymbols

    tickerSymbolPrefix

    primaryTickerSymbol
    placeOfIncorporation
    isAmericanDepositaryReceipt
    viewerDidBookmark
    websiteHref
    investorRelationsHref
    edgarHref
    nasdaqHref(tickerSymbol: $tickerSymbol)
    morningstarHref(tickerSymbol: $tickerSymbol)
    foundedYear
    ipoDate
    standardAndPoorsIndicator
    employeeNumbers {
      totalOfEmployees
      asOfDate
    }
    isInPortfolio
    marketCapitalization {
      totalCapitalization
      asOfDate
    }
    address {
      addressLine1
      addressLine2
      addressLine3
      addressLine4
      city
      state
      country
      postalCode
    }
    securities {
      tickerSymbol
      ipoDate
      isPrimaryShare
      depositoryReceiptType
      depositoryReceiptRatio
      investmentType
      trailingReturns {
        ...TrailingReturnsFields
      }
    }
    standardLogo {
      url
      geometry
      dominantColor
      colorPalette
    }
    niceLogo {
      url
      geometry
      dominantColor
      colorPalette
    }
    financialsTemplate {
      reportStyleName
      industryTemplateName
      templateCode
      globalTemplateCode
    }
    ...RankedIssuerFields
    youtubeVideos {
      ...YouTubeVideoFields
    }
    shares(tickerSymbol: $tickerSymbol) {
      tsoDate
      companyTso
      floatDate
      floatShare
      floatShareToTotalSharesOutstanding
    }
    covers {
      ...CoverFields
    }
    nextUpcomingCalendarEvent {
      eventDate
      eventType

      ... on EarningsResultsEvent {
        eventFiscalYear
      }
    }
    glassdoorRatings {
      glassdoorUrl
      asOfDate
      allReviewsCount
      ratedReviewsCount
      filteredReviewsCount
      overallRating
      reviewCount
      ceoRating
      ceoRatingsCount
      recommendToFriendRating
      cultureAndValuesRating
      diversityAndInclusionRating
      careerOpportunitiesRating
      workLifeBalanceRating
      seniorManagementRating
      compensationAndBenefitsRating
      businessOutlookRating
    }
    chiefExecutiveOfficer {
      ...MorningstarPersonFields
      executiveCompensationHistoryInUSD: executiveCompensationHistory(currency: "USD") {
        ...ExecutiveCompensationHistoryItemFields
      }
      executiveCompensationHistoryInBRL: executiveCompensationHistory(currency: "BRL") {
        ...ExecutiveCompensationHistoryItemFields
      }
    }
  }

  ${MorningstarPersonFields}
  ${ExecutiveCompensationHistoryItemFields}
  ${RankedIssuerFields}
  ${CoverFields}
  ${TrailingReturnsFields}
`;
